<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="_width" :height="_height" :spin="spin" :rtl="rtl" viewBox="0 0 48 48" preserveAspectRatio="xMidYMid meet" fill="" role="presentation" ref="host">
    <g>
      <g data-follow-fill="currentColor" :fill="_fill">
        <path d="M26.1 27.9c.2.4.2.8.2 1.3v4c0 1-.5 2.1-1.3 2.8-.8.7-1.9 1.2-3.1 1.2h-3c-1.1 0-2.2-.5-3.1-1.2s-1.3-1.8-1.3-2.8v-4c0-.5.1-.8.2-1.3C8.2 29.5 3 33.5 3 38.2v3c.2 2.2 2.1 4.1 4.5 4.1h26c2.4 0 4.3-1.8 4.3-4v-3c0-4.8-5.2-8.8-11.7-10.4z" />
        <path d="M20.5 27.7c-1.1 0-2 1-2 2.2v2.2c0 1.2.9 2.2 2 2.2s2-1 2-2.2v-2.2c0-.6-.2-1.1-.6-1.6-.4-.4-.8-.6-1.4-.6zm9.4-19.9v9.4c0 5.2-4.2 9.4-9.4 9.4s-9.4-4.2-9.4-9.4 4.2-9.4 9.4-9.4h9.4zM45 33.2v3c0 2-1.5 3.6-3.5 4 .3-.6.5-1.2.5-2v-3c0-4-3.6-7.4-8.5-9.4v-1.7c0-.5 0-.9-.2-1.3C39.8 24.3 45 28.4 45 33.2z" />
        <path d="M37 2.7v9.4c0 3.6-2 6.7-5 8.3 1.5-1.7 2.4-3.8 2.4-6.2V4.8H23.5c-.7 0-1.3.1-2 .2 1.7-1.4 3.8-2.3 6.1-2.3H37z" />
      </g>
    </g>
  </svg>
</template>

<script setup>
import { ref, computed, onMounted, onUpdated } from 'vue';
const props = defineProps({
  width: {
    type: [Number, String],
    required: false
  },
  height: {
    type: [Number, String],
    required: false
  },
  stroke: {
    type: String,
    required: false
  },
  fill: {
    type: String,
    required: false
  },
  color: {
    type: String,
    required: false
  },
  spin: {
    type: Boolean,
    required: false
  },
  rtl: {
    type: Boolean,
    required: false
  }
});
const size = '1em';

const _fill = computed(() => props.fill || props.color || undefined);
const _stroke = computed(() => props.stroke || props.color || undefined);
const _width = computed(() => props.width || size || undefined);
const _height = computed(() => props.height || size || undefined);
const host = ref(null);

onMounted(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
onUpdated(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
</script>

<style scoped>
svg[spin='true'] {
  animation: iconpark-spin 1s infinite linear;
}

svg[spin='true'][rtl='true'] {
  animation: iconpark-spin-rtl 1s infinite linear;
}

svg[rtl='true'] {
  transform: scaleX(-1);
}
@keyframes iconpark-spin {
  0% {
    -webkit-transform: rotate(0);
    transform: rotate(0);
  }

  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes iconpark-spin-rtl {
  0% {
    -webkit-transform: scaleX(-1) rotate(0);
    transform: scaleX(-1) rotate(0);
  }

  100% {
    -webkit-transform: scaleX(-1) rotate(360deg);
    transform: scaleX(-1) rotate(360deg);
  }
}
</style>
